export const LIST_CAROUSEL_BANNER = `homepage/list-carousel-banner`;
